import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
// img
import u1 from "../../../Assets/images/authbg.png";
import { Link } from "react-router-dom";
import { CstmPagination } from "../../../components/Common/Common";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import CustomPagination from "../../../components/Common/CustomPagination";
import dataHandler from "../../../hooks/dataHandler";
import Axios from "../../../services/Axios";
import Filter from "../../../components/Common/Filter";
import {
  activeInactiveOptions,
  csvImportEnum,
  defaultDeleteModelState,
} from "../../../utilities/const";
import ImportCsv from "../../../components/Common/ImportCsv";
import TableActions from "../../../components/Common/TableActions";
import {
  DELETE_USER,
  USER_LIST,
  USER_STATUS_CHANGE,
} from "../../../services/ApiCalls";
import moment from "moment";
import Toggle from "../../../components/Common/Toggle";
import {
  exportCsvHandler,
  findLabelOfAccountType,
  removeUnderScoreAndCapitalizeFirstLetter,
} from "../../../utilities/utilities";
import ButtonLoader from "../../../components/Common/ButtonLoader";

const ManageUser = () => {
  const [exportLoader, setExportLoader] = useState(false);
  const {
    setBody,
    statusChangeHandler,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    refetch,
    deleteHandler,
  } = dataHandler({
    api: USER_LIST,
    extraBody: {
      role: "USER",
    },
  });
  // const [state , setState] = useState({
  //   status:""
  // });
  // const [filter, setFilter] = useState("");
  // const resetFilter = () => {
  //   setState((pre) => ({
  //     ...pre,
  //     status: "",
  //   }));
  //   setFilter("");
  // };

  const therapists = [
    {
      _id: "687faab7f3902ce5a531bcfd",
      role: "THRIPIST",
      countryCode: "+91",
      date_created_utc: "2025-07-22T15:13:59.634Z",
      status: "inactive",
      wallet: 0,
      fname: "Javan",
      lname: "Sandhu",
      avgRating: 1,
      reviewCount: 1,
      accountType: "single",
      serviceType: [
        {
          _id: "6842b083b034f61b33486005",
          parent: "none",
          subcategories: [],
          sortOrder: 1,
          status: "active",
          commission: 10,
          date_created: "2025-06-06T04:02:06.598Z",
          date_created_utc: "2025-06-06T09:10:27.730Z",
          date_modified: "2025-06-06T04:02:06.598Z",
          date_modified_utc: "2025-06-06T04:02:06.598Z",
          catName: "Life & Career",
          catDesc: "testting",
          catImage: "685e24f67046ed71bcef2199",
          storeType: "667547697b327bb3bcc18e86",
          meta_data: [],
          slug: "life-and-career",
        },
      ],
      totalRevenue: 0,
      orderTotalCount: 0,
      email: "navansandbu@yop.com",
      mobileNumber: "3344766996",
    },
    {
      _id: "687fa869f3902ce5a531bb50",
      role: "THRIPIST",
      countryCode: "+61",
      date_created_utc: "2025-07-22T15:04:09.077Z",
      status: "inactive",
      wallet: 12,
      fname: "Prem",
      lname: "Dhillon",
      avgRating: 3,
      reviewCount: 1,
      accountType: "single",
      serviceType: [
        {
          _id: "6842bfc4f4ca6a4ddf4068b5",
          parent: "none",
          subcategories: [],
          sortOrder: 1,
          status: "active",
          commission: 0,
          date_created: "2025-06-06T09:40:42.366Z",
          date_created_utc: "2025-06-06T10:15:32.447Z",
          date_modified: "2025-06-06T09:40:42.366Z",
          date_modified_utc: "2025-06-06T09:40:42.366Z",
          catName: "Health & Wellness",
          catDesc: "checkingg",
          catImage: "685e24c47046ed71bcef2174",
          storeType: "667547697b327bb3bcc18e86",
          meta_data: [],
          slug: "health-and-wellness",
        },
      ],
      totalRevenue: 57,
      orderTotalCount: 3,
      email: "premdhillon@yop.com",
      mobileNumber: "141444444",
    },
    {
      _id: "687f9f84f3902ce5a531b4b6",
      role: "THRIPIST",
      countryCode: "+91",
      date_created_utc: "2025-07-22T14:26:12.029Z",
      status: "active",
      wallet: 33,
      fname: "Max",
      lname: "Pp",
      avgRating: 5,
      reviewCount: 1,
      serviceType: [],
      totalRevenue: 66,
      orderTotalCount: 2,
      email: "pepsu@yop.com",
      mobileNumber: "3333333996",
    },
    {
      _id: "687f9b7ff3902ce5a531b1bb",
      role: "THRIPIST",
      countryCode: "+61",
      date_created_utc: "2025-07-22T14:09:03.315Z",
      status: "active",
      wallet: 0,
      fname: "Raj",
      lname: "Shami",
      avgRating: 4,
      reviewCount: 1,
      serviceType: [],
      totalRevenue: 0,
      orderTotalCount: 0,
      email: "raju@yop.com",
      mobileNumber: "333333333",
    },
    {
      _id: "687f621df3902ce5a5319339",
      role: "THRIPIST",
      countryCode: "+91",
      date_created_utc: "2025-07-22T10:04:13.710Z",
      status: "active",
      wallet: 0.5,
      fname: "Deep",
      lname: "Ex1",
      avgRating: 1,
      reviewCount: 1,
      serviceType: [],
      totalRevenue: 40,
      orderTotalCount: 1,
      email: "paras@yop.com",
      mobileNumber: "5566555555",
    },
    {
      _id: "687e111cf3902ce5a530e311",
      role: "THRIPIST",
      countryCode: "+61",
      date_created_utc: "2025-07-21T10:06:20.020Z",
      status: "active",
      wallet: 0,
      fname: "Maj",
      lname: "Sameer",
      serviceType: [],
      totalRevenue: 0,
      orderTotalCount: 0,
      email: "cmm@yop.com",
      mobileNumber: "369369123",
    },
    {
      _id: "687dfce5f3902ce5a530da3f",
      role: "THRIPIST",
      countryCode: "+91",
      date_created_utc: "2025-07-21T08:40:05.297Z",
      status: "active",
      wallet: 103,
      fname: "Vinay",
      lname: "Haria",
      avgRating: 3.5,
      reviewCount: 2,
      serviceType: [],
      totalRevenue: 210,
      orderTotalCount: 10,
      email: "cu@yop.com",
      mobileNumber: "1234567893",
    },
    {
      _id: "6878f61b824c4e6d4455c673",
      role: "THRIPIST",
      countryCode: "+91",
      date_created_utc: "2025-07-17T13:09:47.056Z",
      status: "active",
      wallet: 0,
      fname: "Kamz",
      lname: "Z",
      avgRating: 0,
      bankFields: [],
      name: null,
      onlineStatus: "offline",
      reviewCount: 0,
      serviceType: [],
      totalRevenue: 80,
      orderTotalCount: 4,
      email: "kamz@yop.com",
      mobileNumber: "3696691212",
    },
    {
      _id: "68764d4d76567e22c2def491",
      name: null,
      fname: "Akshpreet",
      lname: "singh",
      countryCode: null,
      role: "THRIPIST",
      wallet: 0,
      avgRating: 0,
      reviewCount: 0,
      status: "active",
      onlineStatus: "offline",
      serviceType: [],
      date_created_utc: "2025-07-15T12:45:01.463Z",
      bankFields: [],
      totalRevenue: 0,
      orderTotalCount: 0,
      email: "akshpreetdev@gmail.com",
      mobileNumber: null,
    },
    {
      _id: "6876483076567e22c2def250",
      name: null,
      fname: "",
      lname: "",
      countryCode: null,
      role: "THRIPIST",
      wallet: 0,
      avgRating: 0,
      reviewCount: 0,
      status: "active",
      onlineStatus: "offline",
      serviceType: [],
      date_created_utc: "2025-07-15T12:23:12.342Z",
      bankFields: [],
      totalRevenue: 0,
      orderTotalCount: 0,
      email: null,
      mobileNumber: null,
    },
  ];
  const column = [
    {
      head: "#",
      accessor: "#",
      component: (item, key) => {
        return <>{body.limit * (body.page - 1) + key + 1}</>;
      },
    },
    {
      head: "User Name",
      accessor: "name",
      component: (item, key, arr) => (
        <p className="m-0 themeBlue fw-sbold">
          {item.fname + " " + item.lname}
        </p>
      ),
    },

    // {
    //   head: "Assign Therapist",
    //   accessor: "name",
    //   component: () => {
    //   return therapists.map((therapist) => {
    //     return (
    //       <p className="m-0 themeBlue fw-sbold">
    //         {therapist.fname + " " + therapist.lname}
    //       </p>
    //     );
    //    }).join(", ")
    //     // return (
    //     //   <p className="m-0 themeBlue fw-sbold">
    //     //     {(randomTherapist?.fname || "") +
    //     //       " " +
    //     //       (randomTherapist?.lname || "")}
    //     //   </p>
    //     // );
    //   },
    // },
    { head: "Email", accessor: "email" },
    { head: "Mobile Number", accessor: "mobileNumber" },
    {
      head: "Registered At",
      accessor: "createdAt",
      component: (item, key, arr) => (
        <>{moment(item.date_created_utc).format("DD-MM-YYYY , HH:MM")}</>
      ),
    },
    // {
    //   head: "Account Type",
    //   accessor: "accountType",
    //   component: (item, key, arr) => (
    //     <p className="m-0 themeBlue fw-sbold">
    //       {findLabelOfAccountType(item.accountType)}
    //     </p>
    //   ),
    // },
    {
      head: "Acquisition Insight",
      accessor: "acquisitionInsight",
      component: (item, key, arr) => (
        <p className="m-0">{item.acquisitionInsight || "App"}</p>
      ),
    },
    {
      head: "Status",
      accessor: "status",
      component: (item, key, arr) => (
        <Toggle
          isChecked={item.status === "active"}
          onChange={() =>
            statusChangeHandler(
              () =>
                USER_STATUS_CHANGE({
                  //need its api
                  _id: item._id,
                  status: item.status === "active" ? "inactive" : "active",
                }),
              key
            )
          }
        />
      ),
    },
    {
      head: "Action",
      accessor: "Action",
      component: (item) => (
        <TableActions
          editUrl={`/manage-user/edit/${item._id}`}
          viewLink={`/manage-user/detail/${item._id}`}
          setDeleteModel={() => {
            console.log("modal should open");

            return setDeleteModel({ show: true, dumpId: item?._id });
          }}
        />
      ),
    },
  ];

  return (
    <>
      <ConfirmationPop
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel((p) => defaultDeleteModelState)}
        confirmHandler={() =>
          deleteHandler(() => DELETE_USER({ _id: deleteModel.dumpId }))
        }
        type={"delete"}
      />
      <section className="manageUser py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                User Management
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    setBody={setBody}
                    searchHandler={searchHandler}
                    statusFilterOptionArr={activeInactiveOptions}
                  />
                </div>
                {/* <div className="d-flex align-items-center ps-2">
            <Button
              type="submit"
              className="d-flex align-items-center justify-content-center common-btn px-1"
              onClick={resetFilter}
            >
              <label htmlFor="" className="label m-0">
                Clear
              </label>
            </Button>
          </div> */}
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    <li className="">
                      <ImportCsv
                        item={csvImportEnum.users}
                        callBack={() => refetch()}
                      />
                    </li>
                    <li className="">
                      <Button
                        className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                        type="button"
                        onClick={() =>
                          exportCsvHandler("users", setExportLoader)
                        }
                      >
                        {exportLoader ? <ButtonLoader /> : "Export CSV"}
                      </Button>
                    </li>
                    {/* <li className="">
                      <Link
                        to="/manage-user/add"
                        className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                      >
                        Add New
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageUser;
